import TemplateView from "../../TemplateView";
import LoadingContainer from "../../util/LoadingContainer";
import PageContent from "./PageContent";
import {connect} from '../../redux/utils'
import {bindActionCreators} from 'redux'
import {loadData} from './actions'
import {isFirstLoading} from './selectors'

export class Page extends TemplateView {

    constructor({
        loadData
    }) {
        super(null)

        this.state = {
            firstLoading: false
        }

        this.actions = {
            loadData
        }

        this.onStatePropertyChanged("firstLoading", (firstLoading, prevFirstLoading) => {
            this.loadingContainer.setState({loading: firstLoading})

            if(firstLoading !== prevFirstLoading && firstLoading === true) {
                this.actions.loadData()
            }
        })
    }

    templateHtml() {
        return '<div class="page"\>'
    }

    afterRender() {
        this.contentComponent = new PageContent();
        this.loadingContainer = new LoadingContainer({
            contentComponent: this.contentComponent,
            containerClass: 'workflowSettingsPageLoadingContainer',
            loadingMoireConfig: {
                additionalSpinnerSettings: {
                    radius: 16
                },
            },
            showAnimated: false,
            proxySetState: false
        }).init(this.getEl())
    }
}

export default connect(
    (state) => ({
        firstLoading: isFirstLoading(state),
    }),
    (dispatch) => ({
        loadData: bindActionCreators(loadData, dispatch),
    })
)(Page)



// WEBPACK FOOTER //
// ./web/js/administration/workflowSettings/Page.js